module.exports = __webpack_public_path__ + "img/t7-7.4a631c9c.svg";